import React from 'react';
import Apresentation from './components/apresentation/apresentation';
import Depoiments from './components/depoiments/depoiments';
import EmpretecForYou from './components/empretec-for-you/empreec-for-you';
import EntrepreneurialCharacteristics from './components/entrepreneurial-characteristics/entrepreneurial-characteristics';
import FrequentsQuestions from './components/ffrequents-questions/frequents-questions';
import { Footer } from './components/footer/footer';
import Grow from './components/grow/grow';
import Header from './components/header/header';
import KnowEmpretec from './components/know-empretec/know-empretec';
import Secrets from './components/secrets/secrets';
import Subscription from './components/subscription/subscription';
import { FormProvider } from './hook/form-context';

function Index() {
  return (
    <FormProvider>
      <Header />
      <Apresentation />
      <EmpretecForYou />
      <KnowEmpretec />
      <EntrepreneurialCharacteristics />
      <Grow />
      <Secrets />
      <FrequentsQuestions />
      <Depoiments />
      <Subscription />
      <Footer />
    </FormProvider>
  );
}

export default Index;
